<template>
  <div data-app class="uk-section-">
    <preloader :is-visible="isLoading"></preloader>

    <div class="uk-card uk-card-small uk-card-default">
      <div class="uk-card-header">
        <h3 class="uk-card-title">
          {{ local_page_keys.progress_report }}
        </h3>
      </div>
      <RatingTable :items="items"
                   :loading="loadingRaw"
                   :individual-fields="fields"
                   :multiRow = true
                   :user_id = "user_id"
                   choosenRole="pro-retoucher"
                   :notiferForWeeksData="notiferForWeeksData"
                   @loadMore="getMore"
                   :selectOrder="selectOrder"
                   @openOrder="selectOrder"></RatingTable>
    </div>

    <!--иифо диалоговое окно-->
    <md-dialog
        :md-active.sync="showDialog"
        :md-closed="true"
        :md-clicked-outside="true"
        :md-close-on-esc="true"
        class="tm-dialog-progress-report">
      <div class="uk-padding uk-position-relative tm-modal-page"  style="overflow-y: scroll;">
        <a href="#" class="uk-position-top-right tm-dialog-close" @click="showDialog = false">
          <span class="material-icons">close</span>
        </a>

        <div class="uk-grid uk-flex-middle" data-uk-grid>
          <div class="uk-width-auto">
            <h4>{{ local_page_keys.order_number }}: {{ order_id }}</h4>
          </div>
          <div class="uk-width-expand">
            <div class="uk-grid uk-grid-small uk-flex-center uk-flex-middle" data-uk-grid>
              <div>
                <a href="#" :disabled="activeOrderKey <= 0"
                   class="tm-light tm-light-hover uk-button uk-button-small-padding uk-button-success" role="button"
                   data-uk-tooltip="title: Предыдущий заказ" @click="prevOrder">
                  <span class="material-icons">chevron_left</span>
                </a>
              </div>
              <div>
                <a href="#" :disabled="activeOrderKey >= (activeOrders.length-1)"
                   class="tm-light tm-light-hover uk-button uk-button-small-padding uk-button-success" role="button"
                   data-uk-tooltip="title: Следующий заказ" @click="nextOrder">
                  <span class="material-icons">chevron_right</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="uk-margin" v-if="!activeOrderReload">
          <OrderView></OrderView>
          <hr class="uk-margin-medium">
          <h4 class="uk-margin">{{local_page_keys.title_previous_orders}}:</h4>
          <prev-orders-block-for-admin :currentOrderId="order_id"></prev-orders-block-for-admin>
        </div>
      </div>
    </md-dialog>

  </div>
</template>

<script>
import Preloader from "@/pages/Dashboard/Components/Preloader";
import RatingTable from "@/pages/Dashboard/Tables/RatingTable";
import OrderView from "@/pages/Dashboard/Pages/OrderView";
import PrevOrdersBlockForAdmin from "@/pages/Dashboard/Components/Admin/PrevOrdersBlockForAdmin";
import responsiveMixin from '@/mixins/responsiveMixin';

export default {
  name: 'ProRetouchersProgressReport',
  data: () => ({
    isLoading: true,
    local_page_keys: {},
    showDialog: false,
    page: 0,
    items: [],
    moreItemsButton: true,
    fields: [
      {
        key: 'weekly-bonus',
        key_lang: 'pr_weekly_bonus_for_pro',
        icon: 'percent',
        countIcons: 1,
        title: 'Weekly bonus',
        order: 10,
        role:'pro-retoucher'
      },
      {
        key: 'total',
        icon: 'tag',
        key_lang: 'pr_number_of_orders_for_pro',
        title: 'Orders',
        countIcons: 1,
        order: 20,
        role:'pro-retoucher'
      },
      {
        key: 'sloppy-work',
        key_lang: 'pr_sloppy_work',
        icon: 'gpp_bad',
        countIcons: 1,
        title: 'Sloppy Work',
        withOrders: true,
        order: 95,
        role:'pro-retoucher'
      },
    ],
    order_id: null,
    loadingRaw: false,
    activeOrders: [],
    activeOrderKey: null,
    activeOrderReload: false,
    user_id: null,
    notiferForWeeksData: []
  }),
  components: {
    Preloader, RatingTable, OrderView, PrevOrdersBlockForAdmin
  },
  mixins: [responsiveMixin],
  methods: {
    async getMore(newRequest = false) {
      if (!this.moreItemsButton) {
        return;
      }
      this.loadingRaw = true;
      this.moreItemsButton = false;
      let error = "";
      await this.$store.dispatch('rating/proRetoucherRatingData', {page: this.page, new: newRequest}).catch((reason => {
        this.moreItemsButton = true;
        error = true;
      }));
      if (!error) {
        let ratingRow = await this.$store.getters['rating/proRetoucherRatingData'];
        this.items.push(ratingRow['data']);
        this.user_id = ratingRow['user_id'];

        let firstWeekData = this.items[0][0].rating;
        let dataAllComments = ratingRow['data_all_comments'];

        if (dataAllComments) {
          const merged = {
            ...firstWeekData,
            ...dataAllComments
          };

          for (const key in merged) {
            if (merged[key] && merged[key].count !== undefined) {
              // Считаем сумму значений count
              merged[key].count = (firstWeekData[key]?.count || 0) + (dataAllComments[key]?.count || 0);
            }
            if (merged[key] && merged[key].items !== undefined) {
              // Объединяем массивы items
              merged[key].items = [...(firstWeekData[key]?.items || []), ...(dataAllComments[key]?.items || [])];
            }
          }

          function removeDuplicates(obj, field) {
            const uniqueValues = {};
            obj[field].items = obj[field].items.filter((item) => {
              if (!uniqueValues[item.order_id]) {
                uniqueValues[item.order_id] = true;
                return true;
              }
              return false;
            });
          }

          removeDuplicates(merged, "sloppy-work");
          removeDuplicates(merged, "senior-dislike");

          this.items[0][0].rating = merged;
        }

        this.page++;
        this.moreItemsButton = true;
        this.getNotiferForWeeks();
      }
      this.loadingRaw = false;
    },
    async selectOrder({key, orders}) {
      if(this.isMobile) {
        return;
      }
      this.activeOrders = orders.map((order) => {
        return order.order_id ?? null;
      });
      this.activeOrderKey = key;
      let order_id = this.activeOrders[key];
      await this.openOrder(order_id);
    },
    async openOrder(order_id) {
      this.activeOrderReload = true;
      await this.$store.dispatch('order/setViewOrderId', order_id);
      this.order_id = order_id;
      this.showDialog = true;
      this.activeOrderReload = false;
      location.hash = order_id;
    },
    async nextOrder() {
      if (this.activeOrders[this.activeOrderKey + 1]) {
        await this.openOrder(this.activeOrders[this.activeOrderKey + 1]);
        this.activeOrderKey++;
      }
    },
    async prevOrder() {
      if (this.activeOrders[this.activeOrderKey - 1]) {
        await this.openOrder(this.activeOrders[this.activeOrderKey - 1]);
        this.activeOrderKey--;
      }
    },
    getNotiferForWeeks() {
      this.notiferForWeeksData = [];
      this.items.forEach((item) => {
        item.forEach((item) => {
          let badJobCount = 0;
          let week = item.date.week;
          for (const prop of Object.keys(item.rating)) {
            const data = item.rating[prop].items;
            if (data) {
              const count = data.filter(item => (item.senior_retoucher_quality === "bad-job" && item.last_type_comment === "senior_comment") || (item.last_type_comment === "pro_retoucher_comment" && item.commented_proretoucher === this.user_id)).length;
              badJobCount += count
            }
          }
          this.notiferForWeeksData.push({week: week, value: badJobCount });
        });
      });
    },
  },
  async created() {
    this.local_page_keys = Object.assign({}, await this.$filtergetLocalisationPage('pro_retoucher_progress_report'),await this.$filtergetLocalisationPage('admin_orders_history'));
    this.isLoading = false;
    await this.getMore();
    setInterval(async () => {
      await this.getNotiferForWeeks();
    }, 5 * 60 * 1000);
  },
}
</script>

<style>
/*Layout*/
@import '../../../assets/css/uikit/grid.css';
@import '../../../assets/css/uikit/section.css';
@import '../../../assets/css/uikit/card.css';
@import '../../../assets/css/uikit/table.css';
@import '../../../assets/css/uikit/form.css';
@import '../../../assets/css/uikit/nav.css';
@import '../../../assets/css/uikit/subnav.css';
@import '../../../assets/css/uikit/dropdown.css';
@import '../../../assets/css/uikit/drop.css';
@import '../../../assets/css/uikit/link.css';
@import '../../../assets/css/uikit/modal.css';
@import '../../../assets/css/uikit/accordion.css';

/*Utilities*/
@import '../../../assets/css/uikit/background.css';
@import '../../../assets/css/uikit/label.css';
@import '../../../assets/css/uikit/width.css';
@import '../../../assets/css/uikit/height.css';
@import '../../../assets/css/uikit/flex.css';
@import '../../../assets/css/uikit/margin.css';
@import '../../../assets/css/uikit/padding.css';
@import '../../../assets/css/uikit/position.css';
@import '../../../assets/css/uikit/utility.css';
@import '../../../assets/css/uikit/transition.css';
@import '../../../assets/css/uikit/text.css';
@import '../../../assets/css/uikit/overlay.css';
@import '../../../assets/css/uikit/animation.css';
@import '../../../assets/css/custom.css';

.uk-button-success,
.uk-button-success:hover,
.uk-button-success:focus {
  color: #fff !important;
}
.uk-drop-parent-icon {
  transition: transform .3s ease-out;
}
[aria-expanded=true]>.uk-drop-parent-icon {
  transform: rotateX(180deg)
}
.uk-table-hover>tr:hover, .uk-table-hover tbody tr:hover {
  position: relative;
  z-index: 2;
}
.tm-width-medium {
  width: 240px;
}
.tm-grid-hover > div {
  transition: .1s ease-in-out;
}
.tm-grid-hover > .uk-open,
.tm-grid-hover > div:hover {
  background-color: #f8f8f8;
}
.tm-grid-hover .uk-accordion-title {
  height: 68px;
}
.tm-grid-hover .uk-accordion-title:before {
  display: none;
}
hr,
.uk-hr {
  /* 1 */
  overflow: visible;
  /* 2 */
  text-align: inherit;
  /* 3 */
  margin: 0 0 20px 0;
  border: 0;
  border-top: 1px solid #e5e5e5;
}
/* Add margin if adjacent element */
* + hr,
* + .uk-hr {
  margin-top: 20px;
}
</style>